import React from "react";

const SkeletonLoading = ({ cardCount = 2 }) => {
    return (
        <div className="tw:my-4">
            {[...Array(cardCount)].map((_, index) => (
                <div key={index} className="tw:mb-5 tw:bg-white tw:border tw:border-[#E8E8E8] tw:rounded-lg tw:shadow-sm tw:overflow-hidden tw:animate-pulse">
                    <div className="tw:p-4 tw:md:p-6">
                        {/* Header row: booking id / name / type + status chip */}
                        <div className="tw:flex tw:justify-between tw:items-start tw:gap-4">
                            <div className="tw:flex tw:gap-8 tw:flex-1">
                                {[1, 2, 3].map((item) => (
                                    <div key={item} className="tw:flex-1 tw:max-w-48">
                                        <div className="tw:h-3 tw:w-20 tw:bg-gray-100 tw:rounded tw:mb-2" />
                                        <div className="tw:h-4 tw:w-28 tw:bg-gray-200 tw:rounded" />
                                    </div>
                                ))}
                            </div>
                            <div className="tw:hidden tw:md:block tw:h-9 tw:w-36 tw:bg-gray-200 tw:rounded-md" />
                        </div>

                        <div className="tw:my-4 tw:h-px tw:bg-gray-100" />

                        {/* Pick-up row */}
                        <div className="tw:flex tw:gap-8">
                            <div className="tw:w-1/3 tw:max-w-64">
                                <div className="tw:h-3 tw:w-20 tw:bg-gray-100 tw:rounded tw:mb-2" />
                                <div className="tw:h-4 tw:w-40 tw:bg-gray-200 tw:rounded" />
                            </div>
                            <div className="tw:flex-1">
                                <div className="tw:h-3 tw:w-24 tw:bg-gray-100 tw:rounded tw:mb-2" />
                                <div className="tw:h-4 tw:w-48 tw:bg-gray-200 tw:rounded tw:mb-1" />
                                <div className="tw:h-3 tw:w-64 tw:bg-gray-100 tw:rounded" />
                            </div>
                        </div>

                        <div className="tw:my-4 tw:h-px tw:bg-gray-100" />

                        {/* Drop-off row */}
                        <div className="tw:flex tw:gap-8">
                            <div className="tw:w-1/3 tw:max-w-64">
                                <div className="tw:h-3 tw:w-24 tw:bg-gray-100 tw:rounded tw:mb-2" />
                                <div className="tw:h-4 tw:w-40 tw:bg-gray-200 tw:rounded" />
                            </div>
                            <div className="tw:flex-1">
                                <div className="tw:h-3 tw:w-24 tw:bg-gray-100 tw:rounded tw:mb-2" />
                                <div className="tw:h-4 tw:w-44 tw:bg-gray-200 tw:rounded tw:mb-1" />
                                <div className="tw:h-3 tw:w-56 tw:bg-gray-100 tw:rounded" />
                            </div>
                        </div>

                        {/* Show more */}
                        <div className="tw:mt-4 tw:h-4 tw:w-28 tw:bg-gray-100 tw:rounded" />
                    </div>

                    {/* Price bar */}
                    <div className="tw:flex tw:justify-between tw:items-center tw:bg-[#F9F9F9] tw:border-t tw:border-[#E8E8E8] tw:px-4 tw:md:px-6 tw:py-4">
                        <div className="tw:h-4 tw:w-12 tw:bg-gray-200 tw:rounded" />
                        <div className="tw:h-4 tw:w-24 tw:bg-gray-200 tw:rounded" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default SkeletonLoading;
